import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yrx-svg-sprites',
  templateUrl: './svg-sprites.component.html',
  styleUrls: ['./svg-sprites.component.scss']
})
export class SvgSpritesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
